<template>
  <div @contextmenu.prevent.stop="onContextmenu">
    <sj-question-file :disabled="disabled">
      <sj-question-file-progress v-for="(item, index) in progress"
                                 :key="'percentage' + index"
                                 :percentage="item.percentage"></sj-question-file-progress>
      <sj-question-file-item v-for="(file, index) in files"
                             :key="'file' + index"
                             :poster="file.poster"
                             :disabled="disabled"
                             :show-hover-icons="showHoverIcons"
                             @view="view(file)"
                             @contextmenu.prevent.stop.native="(event)=>{onContextmenu(event, index)}"
                             @remove="remove(index)"
                             :selected="checkedFiles.includes(file)"></sj-question-file-item>
      <el-tooltip
        effect="dark"
        :content="title"
        placement="top">
        <sj-question-file-add :disabled="disabled || files.length > 0"
                              @click="upload"></sj-question-file-add>
      </el-tooltip>
    </sj-question-file>
  </div>
</template>

<script>
import SjQuestionFile from '@/views/question-editor/packages/sj-question-file'
import SjQuestionFileItem from '@/views/question-editor/packages/sj-question-file-item'
import SjQuestionFileAdd from '@/views/question-editor/packages/sj-question-file-add'
import SjQuestionFileProgress from '@/views/question-editor/packages/sj-question-file-progress'
import ContextMenu from '@/views/question-review/components/ContextMenu'

export default {
  components: {SjQuestionFileProgress, SjQuestionFileAdd, SjQuestionFileItem, SjQuestionFile},
  mixins: [],
  inject: ['playVideo', 'uploadVideo'],
  props: {
    value: Array,
    disabled: Boolean,
    title: {
      type: String,
      default: '添加指引视频'
    },
    showHoverIcons: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      progress: [
        // percentage: 0,
      ],
      checkedFiles: [],
    }
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    view (file) {
      this.playVideo(file)
    },
    upload () {
      this.uploadVideo().then((data) => {
        let videoProgress = 0
        let posterProgress = 0
        let progress = {
          percentage: 0,
          file: data.file,
        }
        // 显示进度条
        this.progress.push(progress)
        // 生成请求数据
        let video = new FormData()
        video.append('file', data.file)
        let poster = new FormData()
        poster.append('file', data.poster)
        request.all.alert([
          request('uploadStepTemplateFile', video, {
            onUploadProgress: progressEvent => {
              videoProgress = (progressEvent.loaded / progressEvent.total * 100 | 0)
              progress.percentage = (videoProgress + posterProgress) / 2
            }
          }),
          request('uploadStepTemplateFile', poster, {
            onUploadProgress: progressEvent => {
              posterProgress = (progressEvent.loaded / progressEvent.total * 100 | 0)
              progress.percentage = (videoProgress + posterProgress) / 2
            }
          }),
        ]).then(([{data: src}, {data: poster}]) => {
          this.files.push({src, poster})
        }).finally(() => {
          this.progress.splice(this.progress.indexOf(progress), 1)
        })
      })
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    onContextmenu ({clientX, clientY}, index) {
      // 匹配右击菜单作用域
      ContextMenu().scope !== this.uniqueId && ContextMenu().empty()
      // 判断右击是否在项目上
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        if (!this.checkedFiles.includes(file)) {
          ContextMenu().empty()
          ContextMenu().checked(file)
          this.checkedFiles = ContextMenu().checkedFiles
        }
      } else {
        ContextMenu().empty()
      }
      // 限制拷贝数量
      ContextMenu({pasteMax: Number.MAX_SAFE_INTEGER})
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/SjQuestionGuideVideo.vue